import ctl from '@netlify/classnames-template-literals';

export const wrapperStyle = ctl(`
  flex
  gap-4
`);

export const menuStyle = ctl(`
  w-full
  max-w-[1000px]
  h-auto
  overflow-hidden
  bg-white
  rounded-lg
  py-8
  px-10
`);

export const activeButtonStyle = ctl(`
  bg-green-ncs
  cursor-pointer
`);

export const inactiveButtonStyle = ctl(`
  bg-platinum
  cursor-not-allowed
`);

export const buttonContainerStyle = ctl(`
  flex 
  justify-end
  gap-2
  mt-10
`);
